import { useEffect } from 'react';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { backButton, hapticFeedback } from '@telegram-apps/sdk-react';
import '@/lobby.css';

export function Layout() {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (!backButton.isSupported() || !backButton.isMounted()) {
            return;
        }

        const atRoot = location.pathname === '/';
        if (atRoot) {
            backButton.hide();
            return;
        }

        backButton.show();
        const off = backButton.onClick(() => {
            try {
                hapticFeedback.impactOccurred('light');
            } catch {
                // no-op when not available
            }
            navigate(-1);
        });

        return () => {
            off();
        };
    }, [location.pathname, navigate]);

    const hideTabBar = /^\/games\/[^/]+$/.test(location.pathname);

    return (
        <div className={hideTabBar ? 'app-shell app-shell-no-tabs' : 'app-shell'}>
            <Outlet />
            {!hideTabBar && (
                <nav className="bottom-nav">
                    <NavLink
                        to="/leaderboard"
                        className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')}
                    >
                        <span className="nav-ico">🏆</span>
                        Leaderboard
                    </NavLink>
                    <NavLink to="/" className={({ isActive }) => (isActive ? 'nav-item nav-play active' : 'nav-item nav-play')}>
                        <div className="play-fab">🏆</div>
                        Play
                    </NavLink>
                    <NavLink
                        to="/profile"
                        className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')}
                    >
                        <span className="nav-ico">👤</span>
                        Profile
                    </NavLink>
                </nav>
            )}
        </div>
    );
}
